export const WELCOME_MSG = '欢迎来到北京汇鑫君达知识产权代理有限公司';
export const SLOGON_LINE1 = '知识产权';
export const SLOGON_LINE2 = '创造商业价值';
export const MENU_DATA = [
    {
        name: '首页',
        path: '/',
        active: true,
    },
    {
        name: '服务领域',
        path: 'service',
        active: false,
    },
    {
        name: '行业经验',
        path: 'experience',
        active: false,
    },
    {
        name: '关于我们',
        path: 'aboutUs',
        active: false,
    },
    {
        name: '团队及顾问',
        path: 'team',
        active: false,
    },
    {
        name: '联系我们',
        path: 'contact',
        active: false,
    },
    {
        name: '招聘信息',
        path: 'hire',
        active: false,
    },
];
export const SCOPE_OF_SERVICES = {
    section_title: '服务领域',
    desc: '汇鑫君达擅长以知识产权为工具为客户提供商业化解决方案，建立权利获得、争议解决及商业顾问三个服务板块。在产品创新、市场开拓以及投融资等方面帮助客户挖掘最大价值。',
    acquire_intellectual_property: {
        title: '获得知识产权',
        content_lines: [
            '专利挖掘及布局',
            '商标布局及申请策略',
            '复审及行政诉讼',
            '著作权登记',
            '国外专利及商标申请',
            '专利检索及稳定性评估',
        ],
    },
    dispute_resolution: {
        title: '解决争议',
        content_lines: [
            '专利无效及行政诉讼',
            '商标无效及行政诉讼',
            '专利、商标侵权纠纷',
            '商业秘密侵权纠纷',
            '应用市场、电商平台知识产权纠纷处理',
            '知识产权权属纠纷',
        ],
    },
    business_consulting_services: {
        title: '商业顾问服务',
        content_lines: [
            '产品出口及上市专利风险应对',
            '股权投资前尽职调查',
            '技术调查及技术跟踪',
            '医药医疗器械跨境技术交易',
            '科技项目投融资服务',
            '知识产权转让及许可',
            '企业资质及科技项目申报',
        ],
    },
};
export const EXCEPTIONNAL_INDUSTRY_EXPERIENCE = {
    section_title: '杰出的行业经验',
    desc: '汇鑫君达客户领域涵盖：自动驾驶及新能源汽车、医疗设备、药物研发、工业软件、网络安全、工业机器人、智能仓储、教育、消费类电子、新材料、新能源、金融投资。',
};
// 多维数组，一页是一组，一组显示8个
export const COMPANY_INFO = [
    [
        {
            name: '小鹏汽车',
            image: require('@/assets/images/company/xiaopengqiche.png'),
            logo: require('@/assets/images/company/xiaopengqichelogo.png'),
            desc: '智能电动汽车制造商',
        },
        {
            name: '速腾聚创',
            image: require('@/assets/images/company/suteng.png'),
            logo: require('@/assets/images/company/sutenglogo.png'),
            desc: '提供应用于车载和机器人领域的传感器、解决方案',
        },
        {
            name: '丰图科技',
            image: require('@/assets/images/company/fengtukeji.png'),
            logo: require('@/assets/images/company/fengtulogo.png'),
            desc: '时空大数据服务，构建智慧交通、数字孪生解决方案',
        },
        {
            name: '蘑菇车联',
            image: require('@/assets/images/company/moguchelian.png'),
            logo: require('@/assets/images/company/moguchelianlogo.png'),
            desc: '车路云一体化自动驾驶全栈技术与运营服务提供商',
        },
        {
            name: '智行者',
            image: require('@/assets/images/company/zhixing.png'),
            logo: require('@/assets/images/company/zhixinglogo.png'),
            desc: '自动驾驶整体解决方案服务商',
        },
        {
            name: '祺迹汽车',
            image: require('@/assets/images/company/qiji.png'),
            logo: require('@/assets/images/company/qijilogo.png'),
            desc: '广汽集团旗下新能源商用车解决方案供应商',
        },
        {
            name: '小鹏｜汇天',
            image: require('@/assets/images/company/xiaopenghuitian.png'),
            logo: require('@/assets/images/company/xiaopenghuitianlogo.png'),
            desc: '智能电动飞行汽车解决方案',
        },
        {
            name: '瑞莱智慧',
            image: require('@/assets/images/company/ruilai.png'),
            logo: require('@/assets/images/company/ruilailogo.png'),
            desc: '安全可控人工智能系统提供商，第三代人工智能基础设施和解决方案提供商',
        },
    ],
    [
        {
            name: '生数',
            image: require('@/assets/images/company/shengshu.png'),
            logo: require('@/assets/images/company/shengshulogo.png'),
            desc: '生成式人工智能基础设施及应用建设者',
        },
        {
            name: '安世亚太',
            image: require('@/assets/images/company/anshiyatai.png'),
            logo: require('@/assets/images/company/anshiyatailogo.png'),
            desc: '新型工业品研制者、企业仿真体系和精益研发体系创立者',
        },
        {
            name: '深度视觉科技',
            image: require('@/assets/images/company/shendushijue.png'),
            logo: require('@/assets/images/company/shendushijuelogo.png'),
            desc: '集机器视觉、计算机图像处理及人工智能技术等多项科技为一体的高科技企业',
        },
        {
            name: '深信服科技',
            image: require('@/assets/images/company/shenxinfu.png'),
            logo: require('@/assets/images/company/shenxinfulogo.png'),
            desc: '专注于企业级网络安全、云计算及IT基础设施的产品和服务供应商',
        },
        {
            name: '奇安信',
            image: require('@/assets/images/company/qianxin.png'),
            logo: require('@/assets/images/company/qianxinlogo.png'),
            desc: '中国企业级网络安全市场的领军者',
        },
        {
            name: '优脑银河',
            image: require('@/assets/images/company/younao.png'),
            logo: require('@/assets/images/company/younaologo.png'),
            desc: '脑科学技术供应商',
        },
        {
            name: '晶泰科技',
            image: require('@/assets/images/company/jingtai.png'),
            logo: require('@/assets/images/company/jingtailogo.png'),
            desc: '智能化、自动化驱动的药物研发科技公司',
        },
        {
            name: '科美诊断',
            image: require('@/assets/images/company/kemei.png'),
            logo: require('@/assets/images/company/kemeilogo.png'),
            desc: '临床免疫化学发光诊断检测解决方案提供商',
        },
    ],
    [
        {
            name: '剂泰医药',
            image: require('@/assets/images/company/jitai.png'),
            logo: require('@/assets/images/company/jitailogo.png'),
            desc: '以人工智能（AI）驱动、利用精准靶向的药物递送和药物发现技术进行药物研发的创新型生物技术公司',
        },
        {
            name: '佰诺达',
            image: require('@/assets/images/company/bainuo.png'),
            logo: require('@/assets/images/company/bainuologo.png'),
            desc: '从研发到商业化全流程一站式的生物药多领域CRDMO赋能服务商',
        },
        {
            name: '北芯',
            image: require('@/assets/images/company/beixin.png'),
            logo: require('@/assets/images/company/beixinlogo.png'),
            desc: '高端介入和植入医疗器械提供商',
        },
        {
            name: '当升科技',
            image: require('@/assets/images/company/dangsheng.png'),
            logo: require('@/assets/images/company/dangshenglogo.png'),
            desc: '锂离子电池正极材料专业供应商',
        },
        {
            name: '海柔创新',
            image: require('@/assets/images/company/hairou.png'),
            logo: require('@/assets/images/company/hairoulogo.png'),
            desc: '箱式仓储机器人解决方案提供商',
        },
        {
            name: '红门科技',
            image: require('@/assets/images/company/hongmen.png'),
            logo: require('@/assets/images/company/hongmenlogo.png'),
            desc: '全球领先的智慧安防解决方案提供商',
        },
        {
            name: '志慧芯屏',
            image: require('@/assets/images/company/zhihui.png'),
            logo: require('@/assets/images/company/zhihuilogo.png'),
            desc: '数字化零排放无线显示整体解决方案提供商',
        },
        {
            name: '元旭光电',
            image: require('@/assets/images/company/yuanxu.png'),
            logo: require('@/assets/images/company/yuanxulogo.png'),
            desc: '半导体光电材料和芯片产品研发',
        },
    ],
    [
        {
            name: '精英数智',
            image: require('@/assets/images/company/jingying.png'),
            logo: require('@/assets/images/company/jingyinglogo.png'),
            desc: '应用数字化技术实现矿山智能化高效安全运营的软件解决方案提供商',
        },
        {
            name: '豪鹏科技',
            image: require('@/assets/images/company/haopeng.png'),
            logo: require('@/assets/images/company/haopenglogo.png'),
            desc: '锂离子电池、镍氢电池的研发，废旧电池回收及资源循环利用解决方案提供商',
        },
        {
            name: '飞虎互动',
            image: require('@/assets/images/company/feihu.png'),
            logo: require('@/assets/images/company/feihulogo.png'),
            desc: '远程银行服务的开创者与引领者，专注于研究互动视频+AI技术在金融行业的深度场景化应用',
        },
        {
            name: '智米科技',
            image: require('@/assets/images/company/zhimi.png'),
            logo: require('@/assets/images/company/zhimilogo.png'),
            desc: '智能生活电器产品设计创新与研发的智能硬件公司',
        },
        {
            name: '美容咖usmile',
            image: require('@/assets/images/company/meirong.png'),
            logo: require('@/assets/images/company/meironglogo.png'),
            desc: '将科技美学与使用功效，完美融合于全线口腔护理产品提供商',
        },
        {
            name: '新氧',
            image: require('@/assets/images/company/xinyang.png'),
            logo: require('@/assets/images/company/xinyanglogo.png'),
            desc: '国内领先的医美医疗服务产业集团，提供一站式“大健康”服务',
        },
        {
            name: '零度资本',
            image: require('@/assets/images/company/lingdu.png'),
            logo: require('@/assets/images/company/lingdulogo.png'),
            desc: '开展私募股权投资、企业并购重组、以及创业服务业务的专业性投资管理公司',
        },
        {
            name: '舒克',
            image: require('@/assets/images/company/shuke.png'),
            logo: require('@/assets/images/company/shukelogo.png'),
            desc: '为各种口腔问题提供专业解决方案',
        },
    ],
    [
        {
            name: 'SKG',
            image: require('@/assets/images/company/skg.png'),
            logo: require('@/assets/images/company/skglogo.png'),
            desc: '专注为个人与家庭提供智能可穿戴健康产品的高新技术企业',
        },
        {
            name: '中国体育彩票',
            image: require('@/assets/images/company/tiyu.png'),
            logo: require('@/assets/images/company/tiyulogo.png'),
            desc: '全国体育彩票发行管理',
        },
        {
            name: '达达集团',
            image: require('@/assets/images/company/dada.png'),
            logo: require('@/assets/images/company/dadalogo.png'),
            desc: '中国领先的本地即时零售和配送平台',
        },
    ],
];

export const TEAM_INFO = [
    {
        name: '李辰',
        desc1: '合伙人、专利代理师、技术经纪人',
        desc2: '北京市知识产权局专家库成员',
        image: require('@/assets/images/team/李辰.png'),
        position: ['通信与电子技术', '资深专利专家', '知识产权运营与谈判'],
    },
    {
        name: '黄启法',
        desc1: '合伙人、专利代理师',
        image: require('@/assets/images/team/黄启法.png'),
        position: ['通信与电子技术', '曾在国内排名前三专利代理事务所工作'],
    },
    {
        name: '刘淑珍',
        desc1: '合伙人、专利代理师',
        image: require('@/assets/images/team/刘淑珍.png'),
        position: ['通信、软件、光学', '为科创板首批企业之一的知识产权部创建者', '理工科和法律双重背景'],
    },
    {
        name: '慕丽娟',
        desc1: '合伙人、流程主管',
        image: require('@/assets/images/team/慕丽娟.png'),
        position: ['超过10年的专利流程管理经验', '熟悉国内外主要国家和地区专利程序'],
    },
    {
        name: '许文亮',
        desc1: '专利代理师、律师',
        image: require('@/assets/images/team/许文亮.png'),
        position: ['5年研发经验', '工业机器人', '专利检索及FTO分析', '代表客户：小鹏、速腾聚创、深圳海柔'],
    },
    {
        name: '刘湘菲',
        desc1: '合伙人、专利代理师',
        image: require('@/assets/images/team/刘湘菲.png'),
        position: ['计算机药物研发', '新材料产业的数字化', '消费类电子', '代表客户：晶泰科技、科美诊断、小鹏、SKG等'],
    },
    {
        name: '李梦倩',
        desc1: '合伙人，专利代理师',
        image: require('@/assets/images/team/李梦倩.png'),
        position: [
            '材料工程专业硕士',
            'IVD微流控芯片、蛋白药物技术布局',
            '代表客户：科美诊断、晶泰科技、烽火通信',
            '消费类产品FTO分析',
        ],
    },
    {
        name: '叶才勋',
        desc1: '专利工程师',
        image: require('@/assets/images/team/叶才勋.png'),
        position: ['自动驾驶、视觉人工智能', '专利检索分析', '专利挖掘及布局', '代表客户：智道网联、安世亚太'],
    },
    {
        name: '林晓嘉',
        desc1: '专利工程师',
        image: require('@/assets/images/team/林晓嘉.png'),
        position: [
            '高端装备及动力电池',
            '代表客户：欣旺达电池、豪鹏电池、海信、金发科技、得意精密、海柔机器人',
            '拥有7年的从业经验',
        ],
    },
    {
        name: '林芳',
        desc1: '专利工程师',
        image: require('@/assets/images/team/林芳.png'),
        position: ['生物工程、新材料', '无效分析及侵权对比分析', '代表客户：新锐基因、优理氏、豪鹏电池、科美诊断'],
    },
    {
        name: '刘志红',
        desc1: '专利代理师',
        image: require('@/assets/images/team/刘志红.png'),
        position: [
            '自动化及软件安全',
            '12年起从事知识产权工作',
            '代表客户：联想、爱奇艺、三星电子、中国银行、农业银行',
        ],
    },
    {
        name: '朱雪莲',
        desc1: '专利工程师',
        image: require('@/assets/images/team/朱雪莲.png'),
        position: ['移动通信、自动驾驶、人工智能', '代表客户：比亚迪、苏州浪潮、新氧、小鹏汽车、视联动力、大唐移动'],
    },
    {
        name: '王俊豪',
        desc1: '专利代理师',
        image: require('@/assets/images/team/王俊豪.png'),
        position: [
            '具有机械研发设计经验',
            '主要领域：汽车、新能源汽车、医疗器械',
            '代表客户：广汽研究院、广汽本田、日丰集团、科美诊断、金发科技',
        ],
    },
    {
        name: '王弼天',
        desc1: '专利工程师',
        image: require('@/assets/images/team/王弼天.png'),
        position: [
            '通信工程专业',
            '专注领域：区块链、人工智能',
            '擅长专利驳回复审',
            '代表客户：智道网联、小鹏汽车、湖南区块链实验',
        ],
    },
    {
        name: '陈思',
        desc1: '专利代理师/律师',
        image: require('@/assets/images/team/陈思.png'),
        position: ['新能源汽车、汽车电子', '代表客户：小鹏汽车、烽火通信、精测电子、东风汽车、岚图汽车'],
    },
    {
        name: '冉淑贤',
        desc1: '专利工程师',
        image: require('@/assets/images/team/冉淑贤.png'),
        position: [
            '软件工程专业',
            '曾任职于长城汽车，丰富的的FTO分析、无效分析经验',
            '代表客户：智米科技、安世亚太、智道网联、瑞莱智慧等大型企业',
        ],
    },
    {
        name: '牛艺文',
        desc1: '合伙人、专利代理师',
        image: require('@/assets/images/team/牛艺文.png'),
        position: ['北京知识产权局专家库成员', '技术经纪人', '国家知识产权运营试点平台专家', '工业自动化及高端装备'],
    },
    {
        name: '袁婉芹',
        desc1: '专利工程师',
        image: require('@/assets/images/team/袁婉芹.png'),
        position: ['移动通信、自动驾驶、人工智能', '代表客户：比亚迪、苏州浪潮、新氧、小鹏汽车、大唐移动'],
    },
    {
        name: '陆清文',
        desc1: '专利工程师',
        image: require('@/assets/images/team/陆清文.png'),
        position: [
            '电子信息科学与技术',
            '专注领域：移动通信、自动驾驶、人工智能',
            '代表客户：阿里巴巴、中国电信、比亚迪、小鹏汽车、大唐移动、安世亚太',
        ],
    },
    {
        name: '陈彩云',
        desc1: '商标代理人',
        image: require('@/assets/images/team/陈彩云.png'),
        position: ['2009年开始从事商标工作，熟悉商标全流程工作，具有丰富的商标实务经验，负责企业的商标咨询服务。'],
    },
    {
        name: '黄红胜',
        desc1: '专利代理师',
        image: require('@/assets/images/team/黄红胜.png'),
        position: ['电子信息技术', '自动驾驶、车载电子', '代表客户：东风本田、蘑菇车联、小鹏汽车、豪鹏集团、安世亚太'],
    },
    {
        name: '胡翠琴',
        desc1: '顾问律师',
        image: require('@/assets/images/team/胡翠琴.png'),
        position: [
            '知产宝 中国优秀知产律师TOP200',
            'IPRdily “中国80位50岁以下知识产权精英律师”',
            '多个案件入选法院及国知局典型案例',
            '代表客户：字节跳动、百度、上海联影、北大法宝、科美诊断、中国体彩',
        ],
    },
    {
        name: '陈龙根',
        desc1: '商标代理人',
        image: require('@/assets/images/team/陈龙根.png'),
        position: [
            '北京知产研究会商标法委员会委员',
            '原商标局评审委员会审查员',
            '解决品牌建设、品牌竞争中的关键问题',
            '代表客户：央视动画、银泰百货、达达集团、京东、 美团、中国体彩',
        ],
    },
];

export const ABOUT_US = {
    section_title: '关于我们',
    content_lines: [
        '汇鑫君达成立于2019年，秉承着“知识产权创造商业价值”的理念，在知识产权的权利获得、争议解决、商业化实现方面打造了稳定的团队和丰富的服务经验，旨在帮助客户在产品创新、市场开拓、投融资等领域挖掘最大价值，让企业的优势通过知识产权表达。',
        '汇鑫君达客户行业包括：自动驾驶及新能源汽车、医疗器械、药物研发、工业软件、网络安全、工业机器人、消费类电子、新材料、新能源等。',
        '凭借广泛的合作资源，汇鑫君达依然在技术交易、投融资服务、数据交易医疗器械注册等方面提供帮助。',
    ],
    content_team: '北京、武汉、广州、惠州设有服务团队。',
};

export const COMPANY_ADDRESS = {
    section_title: '公司地址：',
    hello_msg: '准备好了吗？ 那就与我们取得联系吧！',
    content_lines: [
        '北京：朝阳区西大望路3号院蓝堡国际中心1座2801,010-56107503',
        '武汉：洪山区野芷湖西路16号创意天地10号办公楼三层',
        '广州：黄埔区黄埔东路1080号黄埔万科中心T1座1901',
        '惠州：惠城区演达大道2号曼哈顿广场1307-1308',
    ],
    name: '姓名',
    mobile: '联系电话',
    content: '内容',
    submit_btn: '提交',
};
export const RECRUITMENT_INFORMATION = {
    section_title: '招聘信息',
    name: '国内资深专利代理人',
    desc: '领域：计算机软件、通信技术、生物化学、机电',
    duty: '岗位职责：',
    duty_desc: '国内专利服务，包括专利申请撰写、审查意见答复、复审无效、专利检索分析等',
    position_require: '岗位要求：',
    require_list: [
        '1、具有3年以上从业经验；',
        '2、具有较强文字表达、逻辑思维以及沟通协作能力；',
        '3、正规院校相关专业本科及以上学历；',
        '4、服务过国内外一流科技企业，且具有客户认证资质者优先；',
        '5、能够面对压力和挑战；具有责任心。',
    ],
};
export const COPY_RIGHT = '©2024 北京汇鑫君达知识产权代理有限公司 版权所有 京ICP备19020184号';
export default {
    WELCOME_MSG,
    SLOGON_LINE1,
    SLOGON_LINE2,
    MENU_DATA,
    SCOPE_OF_SERVICES,
    EXCEPTIONNAL_INDUSTRY_EXPERIENCE,
    COMPANY_INFO,
    TEAM_INFO,
    ABOUT_US,
    COMPANY_ADDRESS,
    RECRUITMENT_INFORMATION,
    COPY_RIGHT
};
